import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/result/trophy.svg'
import _imports_1 from '@/assets/result/share.svg'


const _withScopeId = n => (_pushScopeId("data-v-5081013e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result__title" }, "Good Job!", -1))
const _hoisted_3 = { class: "result__trophy" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result__trophy-text" }, "Awesome you finished the test", -1))
const _hoisted_6 = { class: "result__result" }
const _hoisted_7 = { class: "result__text" }
const _hoisted_8 = { class: "result__button" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-share" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goReview && _ctx.goReview(...args)))
      }, "Check Your Answears")
    ]),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.resultQuiz.title), 1),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.resultQuiz.text), 1),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeAll && _ctx.closeAll(...args)))
      }, "Done"),
      _hoisted_9
    ])
  ]))
}